import type { CurrentState } from '../../types/analysis.types';

export const vibeMapperCurrentState: CurrentState = {
  build: {
    detected: true,
    tools: ['pnpm', 'pip', 'poetry', 'Docker', 'Terraform', 'Helm'],
    scripts: [
      'dev',
      'build',
      'build:client',
      'build:server',
      'deploy',
      'prisma:generate',
      'prisma:migrate',
    ],
    confidence: 0.95,
    evidence: [
      'package.json with pnpm workspaces',
      'Dockerfile with multi-stage builds',
      'docker-compose.yml for local development',
      'infrastructure/terraform/ modules',
      'App/Site/deploy/helm/ charts',
    ],
  },
  testing: {
    frameworks: [
      { name: 'Playwright', language: 'TypeScript' },
      { name: 'pytest', language: 'Python' },
      { name: 'Vitest', language: 'TypeScript' },
    ],
    coverage: { percentage: undefined, tool: 'v8', threshold: null },
    testCount: 42,
    confidence: 0.88,
    evidence: [
      'playwright.config.ts',
      'App/Site/ai_engine/tests/',
      'coverage threshold in vitest config',
    ],
  },
  deployment: {
    cicd: {
      detected: true,
      platform: 'GitLab CI',
      stages: ['build', 'test', 'deploy'],
    },
    containerization: {
      dockerfile: true,
      kubernetes: true,
    },
    confidence: 0.96,
    evidence: [
      '.gitlab-ci.yml with multi-project pipeline',
      'Dockerfile and Dockerfile.server',
      'docker-compose.yml',
      'Helm charts in App/Site/deploy/helm/',
      'Terraform GKE cluster modules',
    ],
  },
  security: {
    vulnerabilityScanning: false,
    secretsDetection: false,
    codeQuality: {
      linting: true,
      staticAnalysis: ['ESLint', 'TypeScript compiler'],
    },
    secretsManagement: {
      envExamplePresent: true,
      envInGitignore: true,
      secretsManagers: ['HashiCorp Vault'],
      hardcodedSecretsRisk: 'medium',
      containerSecretsIssues: [],
    },
    confidence: 0.9,
    evidence: [
      'vault/ directory with Vault Agent config',
      'App/Site/vault/config/env.tmpl',
      'infrastructure/terraform/helm/platform/templates/vault-agent-configmap.yaml',
      '.env.example present',
      '.gitignore excludes .env files',
    ],
  },
  collaboration: {
    versionControl: { detected: true, type: 'Git' },
    branchStrategy: { strategy: 'trunk-based', branchProtection: false },
    confidence: 0.82,
    evidence: [
      'GitLab repository with active merge requests',
      'main branch with feature branches',
      'CLAUDE.md with contribution guidelines',
    ],
  },
  documentation: {
    readme: true,
    apiDocs: { detected: false },
    architectureDocs: { detected: true },
    changelog: true,
    confidence: 0.93,
    evidence: [
      'README.md at project root',
      'docs/ directory with 28 files',
      'CLAUDE.md with comprehensive project context',
      'docs/deployment/infrastructure.md',
      'docs/security/vault-roles.md',
      'docs/deployment/database.md',
    ],
  },
};
